import axios from "axios";

// axios.defaults.baseURL = "http://localhost:3006/api";
axios.defaults.baseURL = "https://anuscatoolserver.servizilocalispa.it/api";

const Repo = {
  getAllIntents: (data) => {
    var config = {
      method: "post",
      url: "/allIntents",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postIntents: (data) => {
    var config = {
      method: "post",
      url: "/createIntent",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config);
  },

  editIntents: (data) => {
    var config = {
      method: "post",
      url: "/updateIntent",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config);
  },
  deleteIntents: (data) => {
    var config = {
      method: "post",
      url: "/deleteIntent",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config);
  },

  loginUser: (data) => {
    var config = {
      method: "post",
      url: "/login",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config);
  },

  registerUser: (data) => {
    var config = {
      method: "post",
      url: "/user",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config);
  },
};

export default Repo;
